import { hydrate } from 'svelte';
import { DataCard, Gauge } from '../../components';
import { overallScores,getwebScore, refreshDate } from '../api';
import type { DashboardState } from '.';

const homeState: DashboardState = $state({
  gauge: 0,
  refreshDate: 'Date loading...',
})

async function fetchEverythingCollegeHome(groupCode: string) {
  const [homeResponse, websiteScoreResponse, refreshDateResponse] = await Promise.all([
    fetch(overallScores + "/" + groupCode),
    fetch(getwebScore + "/" + groupCode), 
    fetch(refreshDate),
  ]);

  const homeData = await homeResponse.json();
  const websiteScoreData = await websiteScoreResponse.json();
  const refreshDateData = await refreshDateResponse.json();
  console.log(refreshDateData)
  return [homeData, websiteScoreData, refreshDateData]
}

const segmentToFieldName = {
  'academic': 'RecentAllyScore',
  'training': 'RecentTrainingScore',
  'thirdparty': 'RecentThirdPartyScore',
}

async function determineUpstreamFieldName(segment: string) {
  if(segment) {
    return segmentToFieldName[segment as keyof typeof segmentToFieldName]
  } else {
    return segmentToFieldName['academic']
  }
}

async function getDataPoint(segment: string | null, data: any[], webScore?: any) {
  if (segment === 'web') {
    return parseFloat(webScore?.data?.[0]?.SIOverallScore || '0');
  }
  if(segment) {
    return data[0][await determineUpstreamFieldName(segment)]
  } else {
    return '0'
  }
}

async function mountComponents() {
  const gaugeTarget = document.getElementById('uc-home-gauge');
  if (gaugeTarget) {
    hydrate(Gauge, {
      target: gaugeTarget,
      props: {
        dashboardState: homeState,
      }
    });
  }
}

export async function buildHome(groupCode: string) {
  mountComponents();
  const [homeData, websiteScoreData, refreshDateData] = await fetchEverythingCollegeHome(groupCode);

  homeState.gauge = homeData.data[0].RecentAllyScore;
  homeState.refreshDate = refreshDateData.data[0].AllyRefreshDate;

  /**
   * This whole SF component was originally a move to allow for the placement of generic DataCards that could be hydrated by Svelte.
   * In practice, we only use these on the home pages, and each has a unique ID. In the event of a rewrite, we'd probably want to
   * do for each of the four known cards on the page more precisely.
   */
  document.querySelectorAll('.unmounted-data-card').forEach(async (_, i)=> {
    hydrate(DataCard, {
      target: _,
      props: {
        val: await getDataPoint(_.getAttribute('data-segment') ?? '', homeData.data, websiteScoreData),
        title: _.getAttribute('data-title'),
        titleLink: _.getAttribute('data-title-link'),
        item1: _.getAttribute('data-item1'),
        item2: _.getAttribute('data-item2'),
        item3: _.getAttribute('data-item3'),
        item4: _.getAttribute('data-item4'),
        layout: _.getAttribute('data-layout'),
        blurb: _.getAttribute('data-blurb'),
        disabled: _.getAttribute('disabled')
      }
    })
  })
}